import React, { useEffect, useState } from 'react'
import GroupList from '../messageManage/components/GroupList/GroupList'
import '../messageManage/MessageManage.less'
import DyAccountList from './components/accountList/AccountList'
import WorkList from './components/workList/WorkList'
import CommentList from './components/commentList/CommentList'

export default function CommentManage() {
  const [groupId, setGroupId] = useState(0)
  const [third_uid, setThirdUid] = useState('')
  const [teamId, setTeamId] = useState();
  const [aweme_id, setAwemeId] = useState('')
  const [auth_data, setAuthData] = useState({})
  const [num, setNum] = useState(0)
  const [client_id, setClientId] = useState('')
  const onGroupChange = (value) => {
    setGroupId(value)
  }
  const onClickAccount = (value, id) => {
    console.log(value)
    setThirdUid(value.third_uid)
    setTeamId(id)
    console.log(JSON.parse(value.auth_data), '{{{{{}}}}}}')
    const obj = JSON.parse(value.auth_data)
    setAuthData({
      cookie: obj.cookie,
      ua: obj.user_agent,
      ticket: obj.web_protect.ticket,
      ts_sign: obj.web_protect.ts_sign,
      ec_private_key: obj.s_sdk_crypt_sdk.ec_privateKey,
      ec_public_key: obj.s_sdk_crypt_sdk.ec_publicKey,
      cert: obj.s_sdk_server_cert_key
    })
  }
  const onClickWork = (value) => {
    setAwemeId(value.aweme_id)
    setNum(value?.statistics?.comment_count || 0)
  }
  const getClientId = async () => {
    const _client_id = await window?.electron?.ipcRenderer?.getSystemInfo();
    setClientId(_client_id)
  }
  useEffect(() => {
    getClientId()
  }, [])
  return (
    <div className="message-manage-index" style={{ height: 'calc(100vh - 90px)' }}>
      <div className="group-wrapper">
        <GroupList onChange={onGroupChange} canVisible={false} onClickItem={onClickAccount} />
      </div>
      {/* <div className="group-wrapper">
        <DyAccountList groupId={groupId} onClickItem={onClickAccount} client_id={client_id} />
      </div> */}
      <div className="group-wrapper" style={{ width: '400px' }}>
        <WorkList team_id={teamId} third_uid={third_uid} onClickItem={onClickWork} auth_data={auth_data} />
      </div>
      <div className="chat-wrapper">
        <CommentList team_id={teamId} third_uid={third_uid} aweme_id={aweme_id} num={num} auth_data={auth_data} />
      </div>
    </div>
  )
}
